import SVG from 'react-inlinesvg';
import { SortSettings } from 'components/common/types/SortDir.types';
import { SortButtonProps } from './SortButton.types';

const SortButton: React.FC<SortButtonProps> = ({
  dataTestId = 'sort-button',
  label = 'Alphabetical',
  onSort,
  sortDir,
}) => {
  const handleSortClick = (): void => {
    if (!onSort) return;

    const { nextDir } = SortSettings[sortDir];
    onSort(nextDir);
  };

  return (
    <button
      data-test-id={dataTestId}
      className="flex items-center gap-x-2 body-sm text-essential-tertiary"
      type="button"
      onClick={handleSortClick}
    >
      {label} <SVG src={SortSettings[sortDir].icon} className="w-3 h-3" />
    </button>
  );
};

export default SortButton;
